import { TextField } from '@mui/material';
import {
  useFindOneInventoryPartQuery,
  useRemoveInventoryPartMutation,
} from '../../api/api-hooks';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { Item } from '../../utils/sharedTypes';
import { itemValidator } from './inventoryPartsUtils';
import { AddPartsForm } from './inventoryTypes';
import useInventoryPartCreator from './useInventoryPartCreator';
import useInventoryPartUpdater from './useInventoryPartUpdater';

interface Props {
  selectedParts: Item[];
  setSelectedParts: React.Dispatch<React.SetStateAction<Item[]>>;
  editModalOpenFlag: boolean;
  setEditModalOpenFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const addFormInitialState: AddPartsForm = {
  partName: '',
  amount: 0,
};

const InventoryPartsOptionsBar = ({
  selectedParts,
  setSelectedParts,
  editModalOpenFlag,
  setEditModalOpenFlag,
}: Props) => {
  const [deletePart] = useRemoveInventoryPartMutation();
  const partCreator = useInventoryPartCreator();
  const partUpdater = useInventoryPartUpdater();
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedParts}
        setSelectedItems={setSelectedParts}
        handlerMiddleware={(name, value) => ({})}
        itemValidator={itemValidator}
        itemDeleter={deletePart}
        formInstructions='Part name is required'
        addFormInitialState={addFormInitialState}
        itemName='Part'
        editModalOpen={editModalOpenFlag}
        setEditModalOpen={setEditModalOpenFlag}
        dialogSize='sm'
        childrenCreator={(addFormState: AddPartsForm, handler: any) => (
          <>
            <TextField
              autoFocus
              margin='dense'
              name='partName'
              label='Part Name'
              fullWidth
              value={addFormState.partName}
              onChange={handler}
            />
            <TextField
              margin='dense'
              name='amount'
              label='Amount'
              fullWidth
              value={addFormState.amount}
              onChange={handler}
            />
          </>
        )}
        itemCreator={partCreator}
        itemGetter={useFindOneInventoryPartQuery}
        itemUpdater={partUpdater}
      />
    </>
  );
};

export default InventoryPartsOptionsBar;
